// ----------------------------------------------------------------------

const account = {
  displayName: 'João Paiva',
  email: 'joaopaiva@salutec.pt',
  role:'Fisioterapeuta',
  photoURL: '/static/avatarPerfil.jpeg'
};

export default account;
